<div class="row">
    <div class="col-sm-6">
        <h1 class="left-text">{{screenTitles.title}}</h1>
    </div>
    <!--
    <div class="col-sm-6">
        <button mat-raised-button id="addWorkRequestBtn" [hidden]="!btnAllowNewRequest" (click)="addWorkRequest()"
            color="primary" type="button" value="submit"><mat-icon>add_box</mat-icon>New Work Request
        </button>
    </div>
    -->
</div>
<mat-card class="card-section" [hidden]="showFeedbackForm" >
    <!--mat-card-title><h2>All Work Requests - Breakdown By Status - Total: {{totalWorkRequests | number}}</h2></mat-card-title-->
    <mat-card-header>
        <mat-card-title><span>Feedback Breakdown</span></mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="card-container">

        <ngx-charts-advanced-pie-chart [view]="[900,300]" label="Ratings" [results]="overallStatsData"
            [gradient]="true"
            [customColors]="chartCustomColors"
            >
        </ngx-charts-advanced-pie-chart>
    </mat-card-content>
</mat-card>

<mat-card class="card-container" [hidden]="showFeedbackForm">
    <mat-card-header>
        <mat-card-title>
            <span></span>
        </mat-card-title>

        <mat-card-subtitle>
            <span [innerHTML]="screenTitles.instructions"></span>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <div class="row" style="margin-top: 15px;">
            <div class="col-md-6">
                <!--
                <so-search-input [formCtrl]="tableFilter" placeHolder="enter search terms"
                  label="Filter Contents">
                </so-search-input>
                -->
           
                <mat-form-field class="full-width search-field" *ngIf="feedbackList.data.length > 0">
                    <mat-label>Table Filter</mat-label>
                    <input [formControl]="tableFilter" matInput placeholder="enter terms to filter displayed work requests" title="enter search terms" />
                    <button type="button" *ngIf="tableFilter.value!==null" 
                      matSuffix mat-icon-button aria-label="Clear"                       
                      (click)="clearSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                  
                  </mat-form-field>
                  
            </div>

            <div class="buttons-right col-md-6">
                <button type="button" mat-raised-button (click)="exportData('xlsx')">Excel</button>
                <button type="button" mat-raised-button (click)="exportData('csv')">CSV</button>
                <!--button type="button" mat-raised-button (click)="exportData('json')">Json</button
                <button type="button" mat-raised-button (click)="exportData('txt')">Text</button>
                -->


            </div>
        </div>
        <mat-card-header *ngIf="loadingMessage">
            <mat-card-title>
                <span class="alert alert-warning">{{loadingMessage}}</span>
            </mat-card-title>
        </mat-card-header>
        <table mat-table [dataSource]="feedbackList" matSort #feedbackListSort="matSort" matTableExporter
            #exporter="matTableExporter" (exportCompleted)="exportCompleted()" class="mat-elevation-z8">

            <ng-container matColumnDef="wrNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.wrNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Department </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.department}} </td>
            </ng-container>
            <ng-container matColumnDef="requestType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Type </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.requestType}} </td>
            </ng-container>

            <ng-container matColumnDef="businessRequirements">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Business Requirements </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.businessRequirements}} </td>
            </ng-container>


            <ng-container matColumnDef="requestSponsor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sponsor</th>
                <td mat-cell *matCellDef="let feedback"> {{formatResource(feedback.workRequest.sponsors, false)}} </td>
            </ng-container>

            <ng-container matColumnDef="desiredOutcome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Desired Outcome </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.desiredOutcome}} </td>
            </ng-container>
            
            <ng-container matColumnDef="externalInvolvement">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> External Involvement </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.externalInvolvement}} </td>
            </ng-container>

            <ng-container matColumnDef="requestNotes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> request Notes </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.requestNotes}} </td>
            </ng-container>

            <ng-container matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes </th>
                <td mat-cell  *matCellDef="let feedback"> {{feedback.workRequest.notes}} </td>
            </ng-container>
            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Subject </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.subject}} </td>
            </ng-container>
 
            <ng-container matColumnDef="requestorName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requestor </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.requestorName}} </td>
            </ng-container>

            <ng-container matColumnDef="requestorEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requestor Email</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.requestorEmail}} </td>
            </ng-container>

 

            <ng-container matColumnDef="submittedDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted Date</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.submittedDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="submittedDateUTCShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.submittedDateUTC | utcToLocalTime:'shortDate'}} </td>
            </ng-container>
            
 
            <ng-container matColumnDef="closedDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Closed Date</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.closedDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="closedDateUTCShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Closed</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.workRequest.closedDateUTC | date}} </td>
            </ng-container>   
            
            <ng-container matColumnDef="ratingDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Rating Date</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.createdDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="ratingDateUTCShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rating Date</th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.createdDateUTC | utcToLocalTime:'shortDate'}} </td>
            </ng-container>

            <ng-container matColumnDef="rating">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rating </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.rating}} </td>
            </ng-container>

            <ng-container matColumnDef="easeOfSupport">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ease of Support </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.easeOfSupport}} </td>
            </ng-container>


            <ng-container matColumnDef="supportComments">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Support Comments </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.supportComments}} </td>
            </ng-container>

            <ng-container matColumnDef="opportunities">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Opportunities </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.opportunities}} </td>
            </ng-container>
            <ng-container matColumnDef="additionalComments">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Additional Comments </th>
                <td mat-cell *matCellDef="let feedback"> {{feedback.additionalComments}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let feedback">
                    <mat-icon matTooltip="feedback details" matTooltipPosition="left" class="material-icons"
                        >notes</mat-icon>
                       
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row (click)="showFeedback(row)"  *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <table id='noDataTable' class="mat-elevation-z8" *ngIf="feedbackList.data.length === 0">
            <caption class='sr-only'> No Records Found.</caption>
            <thead>
                <tr>
                    <th class='sr-only' [attr.colspan]="displayedColumns.length">
                        Message
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr [style]="'height:45px;'" >
                    <td [attr.colspan]="displayedColumns.length" *ngIf="queryPerformed">
                        No Records Found.
                    </td>
                    <td [attr.colspan]="displayedColumns.length" *ngIf="!queryPerformed">
                        Enter selection criteria and click 'Get Data'
                    </td>
                </tr>
            </tbody>
        </table>

        <mat-paginator [pageSize]="tablePageSize" [pageSizeOptions]="tablePageSizeOptions" 
        (page)="listingPageSizeChange($event)"> </mat-paginator>

    </mat-card-content>

</mat-card>
<app-feedback *ngIf="showFeedbackForm"  [inputWorkRequest]="currentWorkRequest" (closingComponent)="closeFeedbackForm($event, false)"></app-feedback>